__turbopack_context__.v({
  "main": "T8LxKW_main",
  "skill": "T8LxKW_skill",
});
